const Rhumba = {
    name: "Ravensburger Waltz",
    bpm: 176,
    signature: "4/4",
    introMeasures: 8,
    pattern: [

    ]
};

export default Rhumba;